// extracted by mini-css-extract-plugin
module.exports = {"Logo":"SunTimesLogo_Logo__3HDYI","DarkLogo":"SunTimesLogo_DarkLogo__3LZ1c","Star":"SunTimesLogo_Star__2vdua","Small":"SunTimesLogo_Small__35j9u"};